export default __webpack_public_path__ + "static/media/denali.fbeaef0d.png";